module.exports = {
  'african-grey-parrot': 'афричко-сиви папагај',
  alligator: 'алигатор',
  alpaca: 'алпака',
  anteater: 'мравојед',
  antelope: 'антилопа',
  ape: 'мајмун',
  bat: 'слепи миш',
  bee: 'пчела',
  'bowhead-whale': 'кит-прамац',
  buffalo: 'биво',
  butterfly: 'лептир',
  camel: 'камила',
  cat: 'мачка',
  chicken: 'пилетина',
  cow: 'крава',
  crow: 'врана',
  dinosaur: 'диносаурус',
  dog: 'пас',
  dove: 'голубица',
  duck: 'патка',
  elephant: 'слон',
  falcon: 'сокол',
  ferret: 'ферет',
  frog: 'жаба',
  giraffe: 'жирафа',
  'guinea-pig': 'заморче',
  hedgehog: 'јеж',
  hippopotamus: 'нилски коњ',
  horse: 'коњ',
  'humpback-whale': 'грбави кит',
  hyena: 'хијена',
  'komodo-dragon': 'комодо-змај',
  leopard: 'леопард',
  lion: 'лав',
  lizard: 'гуштер',
  moose: 'лос',
  otter: 'видра',
  owl: 'сова',
  panda: 'панда',
  penguin: 'пингвин',
  pig: 'свиња',
  rabbit: 'зец',
  raccoon: 'ракун',
  rat: 'пацов',
  rattlesnake: 'чегртуша',
  rhinoceros: 'носорог',
  robin: 'црвендаћ',
  rooster: 'петао',
  scorpion: 'шкорпион',
  shark: 'ајкула',
  sheep: 'овца',
  swan: 'лабуд',
  tiger: 'тигар',
  turkey: 'ћуретина',
  wolf: 'вук',
  yak: 'јак',
  zebra: 'зебра',
};
